import queryString from 'query-string';
import { Component } from 'react';
import { connect } from 'react-redux';

import {
  CheckoutLayout,
  Logo,
  NeedHelp,
  NeedHelpNoCustomer
} from 'common/components/layout';
// import OrderShippingReceipt from 'profile/orderHistory/components/OrderShippingReceipt';
// import OrderShipmentUpdates from 'profile/orderHistory/components/OrderShipmentUpdates';
import { getMessage } from 'common/helpers/miscHelper';
import { getOrder, getOrderByEmailOrderNumber } from 'redux/orders/actions';

import CustomerDetails from './components/CustomerDetails';
import GiftMessage from './components/GiftMessage';
import OrderDetails from './components/OrderDetails';
import OrderSummaryReceipt from './components/OrderSummaryReceipt';
import ShippingInstructions from './components/ShippingInstructions';

class Receipt extends Component {
  componentDidMount() {
    const { props } = this;
    if (props.match.params.orderId) {
      props.getOrder(props.match.params.orderId);
    } else {
      const { location } = this.props;
      const queryObj = queryString.parse(location.search);
      props.getOrderByEmailOrderNumber(queryObj.email, queryObj.orderNumber);
    }
  }

  componentDidUpdate(prevProps) {
    const { props } = this;
    const { customer, match } = this.props;
    if (!prevProps.customer.data && customer.data) {
      props.getOrder(match.params.orderId);
    }
  }

  render() {
    const { orders, settings, customer, location } = this.props;
    const queryObj = queryString.parse(location.search);
    const { email } = queryObj;
    const { currentOrderId } = this.props;
    if (!settings.data || !orders.data || !currentOrderId) {
      return (
        <CheckoutLayout title="Order Receipt" loading>
          &nbsp;
        </CheckoutLayout>
      );
    }
    const order = orders.data[currentOrderId];
    // const orderCustomer = customer.data || order;
    return (
      <CheckoutLayout title="Order Receipt">
        <div className="c7-checkout">
          <OrderSummaryReceipt order={order} settings={settings} />

          <div className="c7-checkout__main c7-checkout__main--wide">
            <div className="c7-checkout__header">
              <Logo />
              <h2>
                <span>Order No. {order.orderNumber}</span>
                Thank you {customer.data && customer.data.firstName}!
              </h2>
              <div
                dangerouslySetInnerHTML={{
                  __html: getMessage('Order Receipt Message', settings)
                }}
              />
            </div>

            <div className="c7-account__order-detail__customer-details">
              <OrderDetails order={order} settings={settings} />
              <CustomerDetails order={order} />
              <GiftMessage order={order} />
              <ShippingInstructions order={order} />
              {customer.data && (
                <NeedHelp
                  type="Order"
                  orderNumber={order.orderNumber}
                  customer={customer.data}
                  hasContinueShopping
                  settings={settings}
                />
              )}
              {!customer.data && (
                <NeedHelpNoCustomer
                  type="Order"
                  order={order}
                  email={email}
                  hasContinueShopping
                  settings={settings}
                />
              )}
            </div>
          </div>
        </div>
      </CheckoutLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  orders: state.order,
  currentOrderId: state.order.currentOrderId,
  settings: state.setting,
  customer: state.customer
});

export default connect(mapStateToProps, {
  getOrder,
  getOrderByEmailOrderNumber
})(Receipt);
